import useUsers from "../hooks/useUsers";
import usePermissions from "../access-control/queries/usePermissions";
import { RBACAccessLevel, RBACDomain } from "../access-control/types";
import { userHasAccess } from "../access-control/permissions";

export type CanViewDestinationRanks = {
  canViewDestinationRanks: boolean;
  isLoading: boolean;
};

export default function useCanViewDestinationRanks(): CanViewDestinationRanks {
  const usersState = useUsers();
  const { data: rolePermissions, isLoading: permsLoading } = usePermissions();

  if (usersState.loading || permsLoading) {
    return {
      canViewDestinationRanks: false,
      isLoading: true,
    };
  }

  return {
    canViewDestinationRanks: userHasAccess(
      usersState.currentUser,
      rolePermissions,
      RBACDomain.product,
      RBACAccessLevel.read,
    ),
    isLoading: false,
  };
}
